import { render, staticRenderFns } from "./TestConfigEditor.vue?vue&type=template&id=13f52668&scoped=true&"
import script from "./TestConfigEditor.vue?vue&type=script&lang=js&"
export * from "./TestConfigEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f52668",
  null
  
)

export default component.exports